<mat-spinner *ngIf="loading" color="primary" diameter="24"></mat-spinner>
<mat-form-field
  *ngIf="!loading"
  appearance="outline"
  [class.all-width]="fullWidth"
>
  <mat-label>{{ title }}</mat-label>

  <input
    type="text"
    matInput
    [(ngModel)]="company.regularName"
    [matAutocomplete]="auto"
    [disabled]="client || !canEdit"
    (ngModelChange)="onSearchTermChanged($event)"
  />
  <mat-autocomplete
    #auto="matAutocomplete"
    class="taller-panel"
    (optionSelected)="companySelected($event.option)"
    [panelWidth]="325"
  >
    <mat-option *ngFor="let item of searchResult" [value]="item">
      {{ item.regularName }}
      <span *ngIf="!item.dataCorrect"
        >&nbsp;&nbsp;<mat-icon
          matTooltip="Bedrijf nog niet vervolledigd"
          class="data-not-correct-icon"
          >report_problem</mat-icon
        ></span
      >
    </mat-option>
  </mat-autocomplete>
</mat-form-field>
